import axios from 'axios';

// ─── Errores HTTP de las APIs en Nest ────────────────────────────────────────
// Lo genérico de leer un error de axios, para la Mesa de cruces y el modal de
// autorización (las reglas de la base). Funciones puras.

/** Estado HTTP y cuerpo de un error de axios; sin respuesta, `null`. */
export function httpErrorResponse(err: unknown): { status: number; data: unknown } | null {
	if (!axios.isAxiosError(err) || !err.response) return null;
	return { status: err.response.status, data: err.response.data };
}

/** El estado HTTP de un error de axios; `null` sin respuesta. */
export const httpErrorStatus = (err: unknown): number | null => httpErrorResponse(err)?.status ?? null;

/**
 * ¿Es el JSON de error de la API? Nest responde `{ statusCode, message, error }`.
 * Un proxy o el hosting con la API caída responden otra cosa (una página HTML,
 * un texto): eso no es la API diciendo algo, es la API que no responde.
 */
export function isNestErrorBody(status: number, data: unknown): data is { statusCode: number; message?: unknown } {
	return !!data && typeof data === 'object' && (data as { statusCode?: unknown }).statusCode === status;
}

/**
 * ¿Es el 404 de Nest de una ruta que no existe (`Cannot GET /api/…`)? Así responde un módulo apagado. Otro 404 de la
 * API ("La tarjeta 7 no está en la mesa") o uno del proxy, no.
 */
export function isNestMissingRouteError(err: unknown): boolean {
	const response = httpErrorResponse(err);
	if (!response || response.status !== 404 || !isNestErrorBody(404, response.data)) return false;
	const { message } = response.data;
	return typeof message === 'string' && message.startsWith('Cannot ');
}
